import Vue from 'vue'
// import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import {
  button, Row, Col, 
  breadcrumb, breadcrumbItem,
  menu,menuItem,menuItemGroup,submenu
} from 'element-ui'

Vue.use(button)
Vue.use(Row)
Vue.use(Col)
Vue.use(breadcrumb)
Vue.use(breadcrumbItem)
Vue.use(menu)
Vue.use(menuItem)
Vue.use(menuItemGroup)
Vue.use(submenu)

// Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
